import { render, staticRenderFns } from "./stores-modal.vue?vue&type=template&id=ed7cf5a8&scoped=true"
import script from "./stores-modal.vue?vue&type=script&lang=js"
export * from "./stores-modal.vue?vue&type=script&lang=js"
import style0 from "./stores-modal.vue?vue&type=style&index=0&id=ed7cf5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7cf5a8",
  null
  
)

export default component.exports